import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from 'elements';

// @ts-ignore
import { BREAKPOINTS } from "theme/mixins";
import useWindowSize from "utils/useWindowSize";

import { Wrapper, PrevNextPlan, PageCount } from './styled';

import PaginationArrow from "assets/images/navigate_icon.svg";

// @ts-ignore
import { SetSelectedGoalAction } from 'Redux/Global/action';

interface ActionPlanItem {
  [key: string]: any;
}

interface PaginationProps {
  i: number;
  actionPlanData: ActionPlanItem[];
}

const Pagination: React.FC<PaginationProps> = ({ i, actionPlanData: goalsData }) => {
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  return (
    <Wrapper $desktop>
      {i > 0 && (
        <Tooltip title="Previous Goal" alternative={width ? width > BREAKPOINTS.sm : false}>
          <PrevNextPlan
            $prev
            $hide={!(i > 0)}
            onClick={() => {
              dispatch(
                SetSelectedGoalAction({
                  ...goalsData[i - 1],
                  i: i - 1,
                })
              );
            }}
          >
            <img src={PaginationArrow} alt="" />
          </PrevNextPlan>
        </Tooltip>
      )}

      <PageCount>
        Goal {i + 1} of {goalsData?.length}
      </PageCount>

      {i < goalsData?.length - 1 && (
        <Tooltip title="Next Goal" alternative={width ? width > BREAKPOINTS.sm : false}>
          <PrevNextPlan
            $next
            $hide={i === goalsData?.length - 1}
            onClick={() => {
              dispatch(
                SetSelectedGoalAction({
                  ...goalsData[i + 1],
                  i: i + 1,
                })
              );
            }}
          >
            <img src={PaginationArrow} alt="" />
          </PrevNextPlan>
        </Tooltip>
      )}
    </Wrapper>
  );
}

export default Pagination;
